import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UpdateSentinelInput } from "../../../__generated__/globalTypes";
import { UPDATE_SENTINEL } from "../sentinels.queries";
import {
  UpdateSentinelMutation,
  UpdateSentinelMutationVariables,
} from "../../../__generated__/UpdateSentinelMutation";
import { parseParams } from "../../../helpers/clean-object";
import { toast } from "react-toastify";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateSentinel = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateSentinelInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateSentinelMutation,
    UpdateSentinelMutationVariables
  >(UPDATE_SENTINEL);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateSentinel?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateSentinel?.error ?? "Error");
        toast.error(
          "Une Erreur est survenue lors de la modification de la sentinelle"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
